import {
  get,
  post
} from '../../API/cloudFunctions';

const moment = require('moment');


const Analytics = {
  state: {
    graphs: [],
    graphData: [],
  },

  actions: {
    getGraphs({
                commit,
                dispatch
              }) {
      return new Promise((resolve, reject) => {
        post('listGraph').then(result => {
          commit('GET_GRAPHS', {
            graphs: result.graphs
          });
          resolve(result.graphs)
        }).catch(error => {
          reject(error)
        })
      })

    },
    addGraph({
               commit
             }, type) {
      commit('ADD_NEW_GRAPH', type)
    },
    getGraphData({commit}, payload) {
      return new Promise((resolve, reject) => {
        post('queryTimeSeries', payload).then(data => {

          commit('PUSH_DATA', {
            data: data,
            graphId: payload.id
          })
        }).catch(error => {

        })

      })
    },

    queryForData({commit, state, getters}, payload) {
      return new Promise((resolve, reject) => {
        console.log(payload.graphId);
        let graph = state.graphs.find(graph => graph.id === payload.graphId);
        let reqBody = payload.filter;
        reqBody.scope = graph.scope;
        reqBody.range = [moment(graph.range[0]).format('YYYY-MM-DD HH:mm:ss'), moment(graph.range[1]).format('YYYY-MM-DD HH:mm:ss')];
        switch (graph.time) {
          case 'Daily':
            reqBody.interval = "1 hour";
            break;
          case 'last 24H':
            reqBody.interval = "15 minutes";
            break;
          case 'Monthly':
            reqBody.interval = "1 day";
            break;
          case 'Weekly':
            reqBody.interval = "1 day";
            break;
          case 'Range':
            let diffInHours = moment(graph.range[0]).diff(moment(graph.range[1]), 'hours');
            if (diffInHours <= 24) {
              reqBody.interval = "15 minutes"
            } else if (diffInHours <= 168) {
              reqBody.interval = "1 hour"
            } else if (diffInHours <= 672) {
              reqBody.interval = "1 day"
            }
            break;
        }
        post('getRRD', reqBody).then(result => {
          let keys = Object.keys(result.data);
          let graphLegend = {};
          switch (graph.filter.grouping.groupBy) {
            case'gateway_id':
              keys.forEach(key => {
                graphLegend[key] = getters.getGatewaysByScope(graph.scope).find(gateway => gateway.id === key).name
              });
              break;
            case 'project_id':
              keys.forEach(key => {
                graphLegend[key] = getters.getProjectById(graph.scope).find(project => project.id === key).name
              });
              break;
            case 'device_id':
              keys.forEach(key => {
                graphLegend[key] = getters.getGatewayDevices(graph.scope, graph.filter.dataSources.gateway).find(device => device.id === key).name

              });

              break;
            case 'all':

              break;

          }
          commit('PUSH_DATA', {
            data: result.data,
            graphId: payload.graphId,
            legend: graphLegend
          });
          resolve()
        }).catch(error => {
          reject(error)
        })
      })


    },
    saveGraph({commit, state}, payload) {
      let graph = state.graphs.find(item => {
        return item.id === payload.graph.id
      });

      graph.name = payload.graph.name;

      //do not delete the id
      // delete graph.id;
      // if (graph.local) {
      //   delete graph.id
      // }
      graph.range = [moment(graph.range[0]).format('YYYY-MM-DD HH:mm:ss'), moment(graph.range[1]).format('YYYY-MM-DD HH:mm:ss')];
      return new Promise((resolve, reject) => {
        post('addGraph', graph).then(success => {
          let oldId = graph.id;
          graph.id = success.graph_id;
          commit('UPDATE_GRAPH', {id: oldId, graph})
          resolve(success)
        }).catch(error => {
          reject(error)
        })
      })

    },
    applyFilter({commit, dispatch,}, payload) {
      return new Promise((resolve, reject) => {
        dispatch('queryForData', payload).then(success => {
          resolve()
        }).catch(error => {
          reject(error)
        })

      })
    },
    deleteGraph({commit}, payload) {
      return new Promise((resolve, reject) => {
        post("deleteGraph", payload.graphId)
          .then(success => {
            commit("DELETE_GRAPH", payload.graphId);
            resolve(success);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    clearFilter({commit, dispatch}, payload) {
      commit('CLEAR_FILTER', payload)
    }

  },
  mutations: {
    GET_GRAPHS: (state, payload) => {
      state.graphs = [];
      payload.graphs.forEach(graph => {
        state.graphs.push(graph)
      });
    },
    ADD_NEW_GRAPH: (state) => {
      state.graphs.push({
        id: (state.graphs.length + 1).toString(),
        name: 'new Graph',
        time: 'last 24H',
        range: [],
        filter: {dataSources: {gateway: '', device: '', sensor: ''}, grouping: {aggregateBy: null, groupBy: null}},
        local: true,
      })

    },
    PUSH_DATA: (state, payload) => {
      let graphDataIndex = state.graphData.findIndex(items => {
        return items.id === payload.graphId;
      });
      if (graphDataIndex === -1) {
        state.graphData = [{
          id: payload.graphId,
          data: []
        }]
      } else {
        state.graphData[graphDataIndex].data = []
      }

      let graph = state.graphs.find(items => {
        return items.id === payload.graphId;
      });

      let keys = Object.keys(payload.data);
      keys.forEach(key => {
        let trace = {
          x: payload.data[key].x,
          y: payload.data[key].y,
          mode: 'lines+markers',
          name: payload.legend[key],
          line: {shape: 'linear'},
          type: 'scatter'
        };


        if (graphDataIndex === -1) {
          state.graphData[state.graphData.length - 1].data.push(trace)

        } else {
          state.graphData[graphDataIndex].data.push(trace)

        }

      });


    },
    UPDATE_GRAPH: (state, payload) => {
      let graphIndex = state.graphs.findIndex(graph => graph.id === payload.id);
      state.graphs[graphIndex] = payload.graph;
    },
    DELETE_GRAPH: (state, payload) => {

      let graphIndex = state.graphs.findIndex(graph => graph.id === payload.graphId);
      state.graphs.splice(graphIndex, 1);

    },
    CLEAR_FILTER: (state, payload) => {
      let graphIndex = state.graphs.findIndex(graph => graph.id === payload.graphId);
      let graph = state.graphs[graphIndex];
      let graphDataIndex=state.graphData.findIndex(data=>data.id===payload.graphId);
      state.graphData[graphDataIndex].data=[]
      graph.filters = null;
      state.graphs[graphIndex] = graph;

    }

  },

};


export default Analytics



// WEBPACK FOOTER //
// ./src/store/modules/analytics.js